'use strict';
angular.module('buyersService')
.factory('CommonService', ['$rootScope', '$q', '$http', 'Upload','appInfo'
    , function ($rootScope, $q, $http, Upload,appInfo) {

        var service = {};
      
        var emailDetails = {
            'toEmail': '',
            'subject': '',
            'htmlBody': '',
            'txtBody': '',
            'sourceEmail': 'no-reply@wiseberry.com.au',
            'replyToAddress': 'no-reply@wiseberry.com.au',
        };

        var api_key = appInfo.pkey;
        var endpoint = appInfo.endpoint;
        var key = $rootScope.currentUser.authdata;
       
        service.sendEmail = function(emailDetails) {

            var dfd = $q.defer();
            
           // endpoint = 'http://mapp.localhost/w3/';
            
            var dataParams = {
                                usercode: key, 
                                toEmail: emailDetails.toEmail.join(),
                                subject:emailDetails.subject,
                                htmlBody:emailDetails.htmlBody,
                                fromEmail:emailDetails.sourceEmail,
                                replyToEmail:emailDetails.replyToAddress
                          }

            $http({
                    url: endpoint+'agency/sesEmail.json', 
                    method: "POST",
                    params: {api_key: api_key},
                    data: dataParams,
                 }).success(function(data, status, headers, config) {
                     dfd.resolve(data);
                }).error(function(data, status, headers, config) {
                    dfd.reject("Error: Status " + status); 
                });

            return dfd.promise;

        }



        /*service.sendEmail = function(emailDetails) {
            var dfd = $q.defer();

            AWS.config.update({ accessKeyId: awsCreds.access_key, secretAccessKey: awsCreds.secret_key });
            AWS.config.region = 'us-east-1';
            var  ses = new AWS.SES();
            // leader.email = 'anjanshakya@wiseberry.com.au';
            var params = {
                Destination: { /* required 
                    ToAddresses: emailDetails.toEmail
                },
                Message: { /* required 
                    Body: { /* required 
                        Html: {
                            Data: emailDetails.htmlBody,
                        },
                        Text: {
                            Data: emailDetails.txtBody,
                        }
                    },
                    Subject: { /* required 
                        Data: emailDetails.subject
                    }
                },
                Source: emailDetails.sourceEmail, /* required   //no-reply@wiseberry.com.au
                ReplyToAddresses: [
                    emailDetails.replyToAddress
                    /* more items 
                ]
            };
            ses.sendEmail(params, function(err, data) {
                if (err) {
                    dfd.reject('Error: ' + 'Email not send');
                    console.log(err, err.stack); // an error occurred
                }
                else {
                    dfd.resolve(data);
                }
            });

            return dfd.promise;

        }*/

        service.emailTemplate = function(emailContent) {
          var orgIndex = service.indexById($rootScope.currentUser.agencies, $rootScope.currentUser.activeAgency);
          var org = $rootScope.currentUser.agencies[orgIndex];
          var htmlTemplate = '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">' +
            '<html>' +
            '<head>' +
            '<!-- If you delete this meta tag, the ground will open and swallow you. -->' +
            '<meta name="viewport" content="width=device-width" />' +
            '' +
            '<meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />' +
            '<!-- Facebook sharing information tags -->' +
            '<meta property="og:title" content="Wiseberry Listing Pack">' +
            '' +
            '<title>Wiseberry Listing Pack</title>' +
            '   ' +
            '<style>' +
            '* { ' +
            '   margin:0;' +
            '   padding:0;' +
            '}' +
            '* { font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif; }' +
            '' +
            'img { ' +
            '   max-width: 100%; ' +
            '}' +
            '.collapse {' +
            '   margin:0;' +
            '   padding:0;' +
            '}' +
            'body {' +
            '   -webkit-font-smoothing:antialiased; ' +
            '   -webkit-text-size-adjust:none; ' +
            '   width: 100%!important; ' +
            '   height: 100%;' +
            '   background: #822433;' +
            '}' +
            '' +
            '' +
            'a { color: #2BA6CB;}' +
            '' +
            '.btn {' +
            '   text-decoration:none;' +
            '   color: #FFF;' +
            '   background-color: #822433;' +
            '   padding:10px 16px;' +
            '   font-weight:bold;' +
            '   margin-right:10px;' +
            '   text-align:center;' +
            '   cursor:pointer;' +
            '   display: inline-block;' +
            '}' +
            '' +
            'td.callout {' +
            '   padding:15px;' +
            '   background-color:#ECF8FF;' +
            '   margin-bottom: 15px;' +
            '}' +
            '.callout a {' +
            '   font-weight:bold;' +
            '   color: #2BA6CB;' +
            '}' +
            '' +
            'table.social {' +
            '/*     padding:15px; */' +
            '   background-color: #ebebeb;' +
            '   ' +
            '}' +
            '.social .soc-btn {' +
            '   padding: 3px 7px;' +
            '   font-size:12px;' +
            '   margin-bottom:10px;' +
            '   text-decoration:none;' +
            '   color: #FFF;font-weight:bold;' +
            '   display:block;' +
            '   text-align:center;' +
            '}' +
            'a.fb { background-color: #3B5998!important; }' +
            'a.tw { background-color: #1daced!important; }' +
            'a.gp { background-color: #DB4A39!important; }' +
            'a.ms { background-color: #000!important; }' +
            '' +
            '.sidebar .soc-btn { ' +
            '   display:block;' +
            '   width:100%;' +
            '}' +
            '' +
            'ul.list-vertical li{' +
            '   list-style-type:none;' +
            '}' +
            '' +
            'table.head-wrap { width: 100%;}' +
            '' +
            '.header.container table td.logo { padding: 15px; }' +
            '.header.container table td.label { padding: 15px; padding-left:0px;}' +
            '' +
            '' +
            'table.body-wrap { width: 100%;}' +
            '' +
            '' +
            'table.footer-wrap { width: 100%;   clear:both!important;' +
            '}' +
            '.footer-wrap .container td.content  p { border-top: 1px solid rgb(215,215,215); padding-top:15px;}' +
            '.footer-wrap .container td.content p {' +
            '   font-size:10px;' +
            '   font-weight: bold;' +
            '   ' +
            '}' +
            'h1,h2,h3,h4,h5,h6 {' +
            'font-family: "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif; line-height: 1.1; margin-bottom:15px; color:#000;' +
            '}' +
            'h1 small, h2 small, h3 small, h4 small, h5 small, h6 small { font-size: 60%; color: #6f6f6f; line-height: 1.1; text-transform: none; }' +
            '' +
            'h1 { font-weight:200; font-size: 44px; color: #822433;}' +
            'h2 { font-weight:200; font-size: 37px; color: #822433;}' +
            'h3 { font-weight:500; font-size: 27px; color: #822433;}' +
            'h4 { font-weight:500; font-size: 23px; color: #822433;}' +
            'h5 { font-weight:900; font-size: 17px; color: #822433;}' +
            'h6 { font-weight:900; font-size: 14px; text-transform: uppercase; color:#444;}' +
            '' +
            '.collapse { margin:0!important;}' +
            '' +
            'p, ul { ' +
            '   margin-bottom: 10px; ' +
            '   font-weight: normal; ' +
            '   font-size:14px; ' +
            '   line-height:1.6;' +
            '}' +
            'p.lead { font-size:17px; }' +
            'p.last { margin-bottom:0px;}' +
            '' +
            'ul li {' +
            '   margin-left:5px;' +
            '   list-style-position: inside;' +
            '}' +
            'ul.sidebar {' +
            '   background:#ebebeb;' +
            '   display:block;' +
            '   list-style-type: none;' +
            '}' +
            'ul.sidebar li { display: block; margin:0;}' +
            'ul.sidebar li a {' +
            '   text-decoration:none;' +
            '   color: #666;' +
            '   padding:10px 16px;' +
            '/*     font-weight:bold; */' +
            '   margin-right:10px;' +
            '/*     text-align:center; */' +
            '   cursor:pointer;' +
            '   border-bottom: 1px solid #777777;' +
            '   border-top: 1px solid #FFFFFF;' +
            '   display:block;' +
            '   margin:0;' +
            '}' +
            'ul.sidebar li a.last { border-bottom-width:0px;}' +
            'ul.sidebar li a h1,ul.sidebar li a h2,ul.sidebar li a h3,ul.sidebar li a h4,ul.sidebar li a h5,ul.sidebar li a h6,ul.sidebar li a p { margin-bottom:0!important;}' +
            '' +
            '.margin {' +
            '   background: #822433;' +
            '   display:block!important;' +
            '   margin:0 auto!important; /* makes it centered */' +
            '   clear:both!important;' +
            '}' +
            '' +
            '.container {' +
            '   display:block!important;' +
            '   max-width:600px!important;' +
            '   margin:0 auto!important; /* makes it centered */' +
            '   clear:both!important;' +
            '}' +
            '' +
            '.content {' +
            '   padding:15px;' +
            '   max-width:600px;' +
            '   margin:0 auto;' +
            '   display:block; ' +
            '}' +
            '' +
            '.cell {' +
            '   padding:15px;' +
            '   max-width:600px;' +
            '   margin:0 auto;' +
            '   display:table-cell; ' +
            '}' +
            '' +
            '.content table { width: 100%; }' +
            '' +
            '.headerImage {' +
            '    width: 100%;' +
            '    max-width: 600px;' +
            '}' +
            '' +
            '/* Odds and ends */' +
            '.column {' +
            '   width: 300px;' +
            '   float:left;' +
            '}' +
            '.column tr td { padding: 15px; }' +
            '.column-wrap { ' +
            '   padding:0!important; ' +
            '   margin:0 auto; ' +
            '   max-width:600px!important;' +
            '}' +
            '.column table { width:100%;}' +
            '.social .column {' +
            '   width: 270px;' +
            '   min-width: 269px;' +
            '   float:left;' +
            '}' +
            '' +
            '.clear { display: block; clear: both; }' +
            '' +
            '@media only screen and (max-width: 600px) {' +
            '   ' +
            '   a[class="btn"] { display:block!important; margin-bottom:10px!important; background-image:none!important; margin-right:0!important;}' +
            '' +
            '   div[class="column"] { width: auto!important; float:none!important;}' +
            '   ' +
            '   table.social div[class="column"] {' +
            '       width:auto!important;' +
            '   }' +
            '' +
            '}' +
            '</style>' +
            '' +
            '</head>' +
            ' ' +
            '<body bgcolor="#822433" topmargin="0" leftmargin="0" marginheight="0" marginwidth="0">                                ' +
            '<!-- HEADER -->' +
            '<table class="head-wrap" bgcolor="#822433">' +
            '   <tr>' +
            '       <td></td>' +
            '       <td class="header container" align="">' +
            '           ' +
            '           <!-- /content -->' +
            '           <div class="content">' +
            '               <table bgcolor="#822433" >' +
            '                   <tr>' +
            '                       <td><img src="http://www.wiseberry.com.au/img/logo-mailer.png" /></td>' +
            '                       <td align="right">&nbsp;</td>' +
            '                   </tr>' +
            '               </table>' +
            '           </div><!-- /content -->' +
            '           ' +
            '       </td>' +
            '       <td></td>' +
            '   </tr>' +
            '</table><!-- /HEADER -->' +
            '' +
            '<!-- BODY -->' +
            '<table class="container">' +
            '   <tr>' +
            '       <td class="margin" bgcolor="#822433">&nbsp;</td>' +
            '       <td  bgcolor="#FFFFFF">' +
            '           <!-- content -->' +
            '           ' +
            '           <!-- content -->' +
            '           <div class="content" wb:repeatable>' +
            '               <table>' +
            '                   <tr >' +
            '                       <td>' +
            '                           <div wb:edit="wbnl_content01">' + emailContent + '</div>' +
          '                     </td>' +
          '                 </tr>' +
          '             </table>' +
          '         </div><!-- /content -->' +
          '         ' +
          '         ' +
          '         <!-- content -->' +
          '         <div class="content">' +
          '         <table>' +
          '             <tr>' +
          '                 <td class="callout">' +
          '                     <!-- Callout Panel -->' +
          '                     <table bgcolor="" cellpadding="" align="left">' +
          '                         <tr>' +
          '                             <td>' +
          '                                 <!--<span class="agentPhoto">' +
          '                                     <img class="thumbnail" width="100" title="Barry Bisset" alt="Photo: Barry Bisset" src="http://202.51.173.32/agency/215/photos/119tb.jpg">' +
          '                                 </span> -->' +
          '                             </td>' +
          '                             <td>' +
          '                                 <ul class="list-vertical">' +
          '                                     <li><strong>' + $rootScope.currentUser.name + '</strong></li>' +
          '                   <li><strong>Email</strong>&nbsp;<a href="mailto:' + $rootScope.currentUser.email + '">Contact Me!</a></li>' +
          '                                 </ul>' +
          '                             </td>' +
          '                         </tr>' +
          '                     </table>                    ' +
          '                 </td><!-- /callout panel -->' +
          '             </tr>' +
          '         </table></div><!-- /content -->' +
          '         ' +
          '         <!-- content -->' +
          '         <div class="content">' +
          '             <table>' +
          '                 <tr>' +
          '                     <td>' +
          '                         <!-- social & contact -->' +
          '                         <table bgcolor="" class="social" width="100%">' +
          '                             <tr>' +
          '                                 <td>' +
          '                                     <!--- column 1 -->' +
          '                                     <div class="column">' +
          '                                         <table bgcolor="" cellpadding="" align="left">' +
          '                                             <tr>' +
          '                                                 <td>                ' +
          '                                                     <h5 class="">Connect with Us:</h5>' +
          '                                                     <p class=""><a href="http://www.facebook.com/wiseberry" class="soc-btn fb">Facebook</a> <a href="http://www.twitter.com/wiseberry_re" class="soc-btn tw">Twitter</a></p>' +
          '                                                 </td>' +
          '                                             </tr>' +
          '                                         </table><!-- /column 1 -->' +
          '                                     </div>' +
          '                                     ' +
          '                                     <!--- column 2 -->' +
          '                                     <div class="column">' +
          '                                         <table bgcolor="" cellpadding="" align="left">' +
          '                                             <tr>' +
          '                                                 <td>                ' +
          '                                                                         ' +
          '                                                     <h5 class="">Contact Info:</h5> ' +
          '                                                     <p><strong>' + (org.organisation ? org.organisation:'Head Office') + '</strong><br>' +
            (org.address ? org.address : '') +
          '                                 <br />Phone: <strong>' +
            (org.phone ? org.phone : '(02) 8883 4832') +

          '                                 </strong></p>' +
          '                                                 </td>' +
          '                                             </tr>' +
          '                                         </table><!-- /column 2 -->  ' +
          '                                     </div>' +
          '                                     <div class="clear"></div>' +
          '                                </td>' +
          '                             </tr>' +
          '                         </table><!-- /social & contact -->' +
          '                         ' +
          '                     </td>' +
          '                     ' +
          '                 </tr>' +
          '                 <tr>' +
          '                     <td align="center">' +
          '                         <p>' +
          '                             <a class="wblink" href="http://www.wiseberry.com.au/terms">Terms</a> ' +
          '                             | <a class="wblink" href="http://www.wiseberry.com.au/privacy">Privacy</a>' +
          '             </p>' +
          '                     </td>' +
          '                 </tr>' +
          '             </table>' +
          '         </div><!-- /content -->' +
          '         ' +
          '' +
          '     </td>' +
          '     <td class="margin" bgcolor="#822433">&nbsp;</td>' +
          ' </tr>' +
          '</table><!-- /BODY -->' +
          '</body>' +
          '</html>';
          return htmlTemplate;
        }


        service.indexById = function(arrObjects, idValue){
            for (var i=0; i < arrObjects.length; i++) {
              if (arrObjects[i].id === idValue) {
                return i;
              }
            }
            return -1;
        }
        
        service.indexByField = function(arrObjects, fieldName, fieldValue){
            for (var i=0; i < arrObjects.length; i++) {
              if (arrObjects[i][fieldName] === fieldValue) {
                return i;
              }
            }
            return -1;
        }

        service.sendSMS = function(smsData) {
            var dfd = $q.defer();

            $http({
                url: $rootScope.endpoint+'wolusers/sendSMS.json', 
                method: "POST",
                params: {api_key: api_key}, 
                data: { 
                    usercode: key, 
                    identifier: $rootScope.currentUser.identifier, 
                    // identifier: 'headoffice', 
                    sms_text: smsData.smsMessage, 
                    sms_signature: smsData.smsSignature, 
                    sms_save_signature: smsData.saveSignature, 
                    sms_type: smsData.smsType,
                    mobiles: smsData.mobiles 
                }
            }).success(function(data) {
                dfd.resolve(data);
            }).error(function(data, status, headers, config) {
                console.log('Error:' + status)
                dfd.reject('Error: ' + 'SMS not send'); 
            });

            return dfd.promise;
        }

        service.getSMSSignature = function(smsType) {
            

           var dfd = $q.defer();
            
           $http({
                    url: $rootScope.endpoint +'wolusers/smssignature.json', 
                    method: "GET",
                    params: {
                        usercode: key, 
                        api_key: api_key,
                        identifier: $rootScope.currentUser.identifier, 
                        // identifier: 'headoffice',
                        smsType: smsType 
                    },
                }).success(function(data) {
                    dfd.resolve(data);
                }).error(function(data, status, headers, config) {
                    dfd.reject("Error: request returned status " + status); 
                });

            return dfd.promise;
        }

        service.fixExifRotation = function(images) {
            var dfd = [];
            var i = 1;
            angular.forEach(images, function(image,i) {
              dfd.push(Upload.applyExifRotation(image.file));
              i++;
            });
            return $q.all(dfd);
        }


        service.emailTemplateSimple = function(bodyHTML) {

            var emailHTML = '<!doctype html>' +
              ' <html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">' +
            ' <head>' +
            ' <title></title>' +
            ' <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">' +
            ' <style type="text/css">' +
            ' #outlook a { padding: 0; }' +
            '       .ReadMsgBody { width: 100%; }' +
            '       .ExternalClass { width: 100%; }' +
            '       .ExternalClass * { line-height:100%; }' +
            '           body { margin: 0; padding: 0; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; }' +
            '           table, td { border-collapse:collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; }' +
            '           img { border: 0; height: auto; line-height: 100%; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic; }' +
            '           p { display: block; margin: 13px 0; }' +
            '       </style>' +
            '           <!--[if !mso]><!-->' +
            '            <style type="text/css">' +
            '@media only screen and (max-width:480px) {' +
                '       @-ms-viewport { width:320px; }' +
                '    @viewport { width:320px; }' +
                '               }' +
            '       </style>' +
            '           <!--<![endif]-->' +
            '           <!--[if mso]>' +
            '       <xml>' +
            '           <o:OfficeDocumentSettings>' +
            '           <o:AllowPNG/>' +
            '           <o:PixelsPerInch>96</o:PixelsPerInch>' +
            '           </o:OfficeDocumentSettings>' +
            '           </xml>' +
            '           <![endif]-->' +
            '            <style type="text/css">' +
            '  @media only screen and (min-width:480px) {' +
                '       .mj-column-per-100, * [aria-labelledby="mj-column-per-100"] { width:100%!important; }' +
                '           }' +
            '       </style>'+
            '           </head>' +
            '           <body style="background: #e8e8e8;">' +
            '             <div style="background-color:#e8e8e8;"><!--[if mso | IE]>' +
            '       <table border="0" cellpadding="0" cellspacing="0" width="600" align="center" style="width:600px;">' +
            '             <tr>' +
            '             <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;">' +
            '             <![endif]--><div style="margin:0 auto;max-width:600px;background:#830b2c;"><table cellpadding="0" cellspacing="0" style="font-size:0px;width:100%;background:#830b2c;" align="center" border="0"><tbody><tr><td style="text-align:center;vertical-align:top;font-size:0px;padding:20px 0px;padding-bottom:20px;padding-top:20px;"><!--[if mso | IE]>' +
            '        <table border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:top;width:600px;">' +
            '             <![endif]--><div aria-labelledby="mj-column-per-100" class="mj-column-per-100" style="vertical-align:top;display:inline-block;font-size:13px;text-align:left;width:100%;"><table cellpadding="0" cellspacing="0" style="vertical-align:top;" width="100%" border="0"><tbody><tr><td style="word-break:break-word;font-size:0px;padding:10px 25px;padding-top:0px;padding-bottom:0px;padding-right:0px;padding-left:0px;" align="left"><table cellpadding="0" cellspacing="0" style="border-collapse:collapse;border-spacing:0px;" align="left" border="0"><tbody><tr><td style="width:200px;"><a href="https://wiseberry.com.au" target="_blank"><img alt="Wiseberry logo" title="" height="auto" src="https://s3-ap-southeast-2.amazonaws.com/wb-docs/EDM-Resources/logo.png" style="border:none;border-radius:;display:block;outline:none;text-decoration:none;width:100%;height:auto;" width="200"></a></td></tr></tbody></table></td></tr></tbody></table></div><!--[if mso | IE]>' +
            '       </td></tr></table>' +
            '           <![endif]--></td></tr></tbody></table></div><!--[if mso | IE]>' +
            '       </td></tr></table>' +
            '           <![endif]-->' +
            '           <!--[if mso | IE]>' +
            '       <table border="0" cellpadding="0" cellspacing="0" width="600" align="center" style="width:600px;">' +
            '             <tr>' +
            '             <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;">' +
            '             <![endif]--><div style="margin:0 auto;max-width:600px;background:#fefefe;"><table cellpadding="0" cellspacing="0" style="font-size:0px;width:100%;background:#fefefe;" align="center" border="0"><tbody><tr><td style="text-align:center;vertical-align:top;font-size:0px;padding:20px 0px;padding-bottom:20px;padding-top:20px;"><!--[if mso | IE]>' +
            '       <table border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:top;width:600px;">' +
            '             <![endif]--><div aria-labelledby="mj-column-per-100" class="mj-column-per-100" style="vertical-align:top;display:inline-block;font-size:13px;text-align:left;width:100%;">' +
            '               <table cellpadding="0" cellspacing="0" style="vertical-align:top;" width="100%" border="0"><tbody><tr><td style="word-break:break-word;font-size:0px;padding:10px 25px;" align="left">' +
            '               <div style="cursor:auto;color:#626262;font-family:Arial, sans-serif;font-size:12px;line-height:14px;">' +
                bodyHTML +
            '           </div>' +
            '           </td></tr><tr><td style="word-break:break-word;font-size:0px;padding:10px 25px;" align="left"><div style="cursor:auto;color:#999999;font-family:Arial, sans-serif;font-size:12px;line-height:14px;">You can only use the personal information contained in this email enquiry for the purposes of contacting the person about their enquiry. You must comply with the Privacy Act 1988 (Cth).' +
            '           </div></td></tr></tbody></table></div><!--[if mso | IE]>' +
            '       </td></tr></table>' +
            '           <![endif]--></td></tr></tbody></table></div><!--[if mso | IE]>' +
            '       </td></tr></table>' +
            '           <![endif]-->' +
            '           <!--[if mso | IE]>' +
            '       <table border="0" cellpadding="0" cellspacing="0" width="600" align="center" style="width:600px;">' +
            '              <tr>' +
            '             <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;">' +
            '             <![endif]--><div style="margin:0 auto;max-width:600px;background:#830b2c;"><table cellpadding="0" cellspacing="0" style="font-size:0px;width:100%;background:#830b2c;" align="center" border="0"><tbody><tr><td style="text-align:center;vertical-align:top;font-size:0px;padding:20px 0px;padding-bottom:0px;padding-top:0px;"><!--[if mso | IE]>' +
            '       <table border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:top;width:600px;">' +
            '             <![endif]--><div aria-labelledby="mj-column-per-100" class="mj-column-per-100" style="vertical-align:top;display:inline-block;font-size:13px;text-align:left;width:100%;"><table cellpadding="0" cellspacing="0" style="vertical-align:top;" width="100%" border="0"><tbody><tr><td style="word-break:break-word;font-size:0px;padding:10px 25px;" align="left"><div style="cursor:auto;color:#ffffff;font-family:Arial, sans-serif;font-size:12px;line-height:22px;">' +
            '             Message sent from Wiseberry buyers app.' +
            '             </div></td></tr></tbody></table></div><!--[if mso | IE]>' +
            '       </td></tr></table>' +
            '           <![endif]--></td></tr></tbody></table></div><!--[if mso | IE]>' +
            '       </td></tr></table>' +
            '           <![endif]-->' +
            '           <!--[if mso | IE]>' +
            '       <table border="0" cellpadding="0" cellspacing="0" width="600" align="center" style="width:600px;">' +
            '             <tr>' +
            '             <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;">' +
            '             <![endif]--><table cellpadding="0" cellspacing="0" style="font-size:0px;width:100%;" border="0"><tbody><tr><td><div style="margin:0 auto;max-width:600px;"><table cellpadding="0" cellspacing="0" style="font-size:0px;width:100%;" align="center" border="0"><tbody><tr><td style="text-align:center;vertical-align:top;font-size:0px;padding:20px 0px;padding-bottom:20px;padding-top:20px;"><!--[if mso | IE]>' +
            '       <table border="0" cellpadding="0" cellspacing="0"><tr><td style="vertical-align:middle;width:600px;">' +
            '             <![endif]--><div aria-labelledby="mj-column-per-100" class="mj-column-per-100" style="vertical-align:middle;display:inline-block;font-size:13px;text-align:left;width:100%;"><table cellpadding="0" cellspacing="0" style="vertical-align:middle;" width="100%" border="0"><tbody><tr><td style="word-break:break-word;font-size:0px;padding:10px 25px;padding-top:0px;padding-bottom:0px;padding-right:25px;padding-left:25px;" align="center"><div style="cursor:auto;color:#000000;font-family:Arial, sans-serif;font-size:11px;line-height:22px;">' +
            '           ©2016 Wiseberry Real Estate' +
            '           </div></td></tr><tr><td style="word-break:break-word;font-size:0px;padding:10px 25px;padding-top:0px;padding-bottom:0px;padding-right:25px;padding-left:25px;" align="center"><div style="cursor:auto;color:#000000;font-family:Arial, sans-serif;font-size:11px;line-height:22px;"> c3/3 Burbank Place Norwest Business Park, Baulkham Hills 2153 NSW Australia' +
            '            </div></td></tr><tr><td style="word-break:break-word;font-size:0px;padding:10px 25px;padding-top:0px;padding-bottom:0px;padding-right:25px;padding-left:25px;" align="center"><div style="cursor:auto;color:#000000;font-family:Arial, sans-serif;font-size:11px;line-height:22px;">Contact: 02 8883 4832 (9.00am - 5.00pm AEST)' +
            '       </div></td></tr></tbody></table></div><!--[if mso | IE]>' +
            '       </td></tr></table>' +
            '           <![endif]--></td></tr></tbody></table></div></td></tr></tbody></table><!--[if mso | IE]>' +
            '       </td></tr></table>' +
            '           <![endif]--></div>' +
            '</body>' +
            '</html>';
            return emailHTML;
        }




        return service;
}]);
